export var TabsSettings;

(function (TabsSettings) {
  TabsSettings["RELATIVE"] = "RELATIVE";
  TabsSettings["ABSOLUTE"] = "ABSOLUTE";
})(TabsSettings || (TabsSettings = {}));